import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { PoreskoOslobodjenje } from './poresko-oslobodjenje';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-poresko-oslobodjenje-update',
  templateUrl: './poresko-oslobodjenje-update.component.html'
})
export class PoreskoOslobodjenjeUpdateComponent extends BaseUpdateComponent<PoreskoOslobodjenje> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'PORESKOOSLOBODJENJE.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(500), 'maxlength', 'PORESKOOSLOBODJENJE.NAZIV.VALIDATION.MAXLENGTH');

  }

}
